'use client';

import {
  StructuredContent,
  type StructuredContentDocument,
} from '@repo/contracts/multi-use/structured-content/types';
import { getChildHeadingId } from '@repo/contracts/multi-use/structured-content/utils';
import { useMemo } from 'react';
import { renderStructuredContent } from '../../rendererContext';
import type { RendererProps } from '../../types';

export type ContentSectionProps = StructuredContentDocument<{
  children: StructuredContent;
  rendererProps?: RendererProps;
}>;

export const ContentSection = (sccProps: ContentSectionProps) => {
  const {
    props: { children, rendererProps },
  } = sccProps;

  const headingId = useMemo(() => getChildHeadingId(sccProps), [sccProps.props.children]);
  return (
    <section aria-labelledby={headingId}>
      {renderStructuredContent(children, rendererProps)}
    </section>
  );
};
